module.exports = __webpack_public_path__ + "img/yellow-tick.8facafbf.svg";